import { render, staticRenderFns } from "./ApprovalAwait.vue?vue&type=template&id=e20ef78a&scoped=true"
import script from "./ApprovalAwait.vue?vue&type=script&lang=js"
export * from "./ApprovalAwait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20ef78a",
  null
  
)

export default component.exports